// src/content_option.js
const logotext = 'Haseeb Khan'
const meta = {
  title: 'Haseeb Khan',
  description:
    'I am Haseeb Khan _ Full stack engineer, currently working in Canada',
}

const introdata = {
  title: 'Haseeb Khan',
  description: 'It is what it is.',
  img_url:
    'https://lh3.googleusercontent.com/d/1oGpKeCgtDRfR1Ksx7HkljseGmnPRX-5j',
  links: {
    work: 'Work',
    blog: 'Blog',
    projects: 'Projects',
  },
}

const blogdata = {
  description: {
    first: 'Ramblings of my mind.',
    second: 'Yap yap yap yap!',
    third: 'Make a wish!',
  },
  img_url:
    'https://lh3.googleusercontent.com/d/1IdcUhSCH6LNCjvRtoR9d8i5Qg1RDOxV0',
  blogposts: [
    {
      name: 'What should I write about first?',
      date: 'Soon, 2025',
      route: '/',
      content: 'This is the content for my first post.',
    },
  ],
}

const aboutdata = {
  title: 'abit about my self',
  aboutme:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis dolor id ligula semper elementum feugiat pretium nulla. Nunc non commodo dolor. Nunc mollis dignissim facilisis. Morbi ut magna ultricies.',
}

const socialprofiles = {
  github: 'https://github.com/haseebk',
  linkedin: 'https://linkedin.com/in/k-haseeb',
}

export { meta, aboutdata, introdata, socialprofiles, logotext, blogdata }
